<template>
  <div class="mt-5">
    <div class="s-layout__index_header">
      <!-- {{ $route.meta.title }} -->
    </div>

    <br />
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  
}
</script>